export default __webpack_public_path__ + "static/media/moden_college.c33bbe1c.jpeg";